import { apiRequest } from 'api/apiClient';

const getUserDetails = async () => {
  const response = await apiRequest('GET', '/v1/users/profile-info', null);
  return response;
};

const getInvitation = async ({ uid }) => {
  const response = await apiRequest('GET', `/v1/users/invitation/${uid}`, null);
  return response;
};

const getDeferredLogin = async () => {
  const response = await apiRequest('POST', '/v1/users/login-handoff', {});
  return response;
};

const AUTH_QUERIES = {
  GET_USER_DETAILS: getUserDetails,
  GET_INVITATION: getInvitation,
  GET_DEFERRED_LOGIN: getDeferredLogin,
};

export default AUTH_QUERIES;
